/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
'use client';
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import clsx from 'clsx';
import { Lottie } from '@/components/LottieWrapper';

import { SM_BREAKPOINT } from '@/lib/constants';
import { useLottieLoader } from '@/lib/useLottieLoader';

interface TabLifted {
  title: string;
  icon: {
    src: string;
    alt: string;
  };
  lottie: {
    desktop: object | string;
    mobile: object | string;
  };
}

interface TabLiftedComponentProps {
  tabs: TabLifted[];
}

export const TabLifted: React.FC<TabLiftedComponentProps> = ({ tabs }) => {
  const [activeTabLifted, setActiveTabLifted] = useState<number>(0);
  const [isMobile, setIsMobile] = useState<boolean>(false);

  const handleTabLiftedClick = (index: number) => {
    setActiveTabLifted(index);
  };

  useEffect(() => {
    if (window.innerWidth < SM_BREAKPOINT) {
      setIsMobile(true);
    }
  }, []);

  const animationData = useLottieLoader(
    String(isMobile ? tabs[activeTabLifted].lottie.mobile : tabs[activeTabLifted].lottie.desktop),
  );
  return (
    <div className="w-full text-white">
      <ul className="flex max-w-max list-none gap-[6px]">
        {tabs.map((TabLifted, index) => (
          <li
            key={`${TabLifted.title}-${index}`}
            className={clsx(
              `flex w-14 min-w-0 cursor-pointer items-center justify-center gap-2 rounded-t-lg px-4 py-3 text-center text-eyebrow-sm text-white transition-colors hover:bg-[#1a2123] md:w-auto md:min-w-[120px] md:rounded-t-2xl lg:px-7`,
              activeTabLifted === index ? 'bg-[#1a2123]' : 'bg-[#010002]',
            )}
            onClick={() => handleTabLiftedClick(index)}
          >
            <div className="relative size-6">
              <Image src={TabLifted.icon.src} alt={TabLifted.icon.alt} fill />
            </div>
            <span className="hidden md:flex">{TabLifted.title}</span>
          </li>
        ))}
      </ul>
      <div className="flex rounded-2xl rounded-tl-none rounded-tr-none bg-gray-6 p-6 md:p-12 lg:rounded-tr-2xl">
        <div className="w-full">
          <div className="m-0 flex h-full md:h-96">
            <Lottie
              animationData={animationData}
              autoplay={true}
              loop={false}
              style={{
                width: 'auto',
                margin: '0',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
